import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7 5h14v2H7z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "4",
  cy: "6",
  r: "1.5"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M7 11h14v2H7zm0 6h14v2H7zm-3 2.5c.82 0 1.5-.68 1.5-1.5s-.67-1.5-1.5-1.5-1.5.68-1.5 1.5.68 1.5 1.5 1.5z"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "4",
  cy: "12",
  r: "1.5"
}, "3")], 'FormatListBulletedTwoTone');